module.exports = __webpack_public_path__ + "static/media/image2_step3.04641c34.svg";